import type { DeliveryAddressOut } from '@/shared/api/intranet'

export const SHOP_DELIVERY_ADDRESS_LIST: (keyof DeliveryAddressOut)[] = ['country', 'city', 'address', 'postal_code']
/** Максимальная длина почтового индекса при оформлении заказа */
export const POSTAL_CODE_MAX_LENGTH = 10
export const SHOP_PHOTOS_MAX_FILE_SIZE_5_MB = 5 * 1024 * 1024
/** Минимальная длина поискового запроса по заказам (короче — поиск не выполняется) */
export const ORDERS_SEARCH_MIN_QUERY_LENGTH = 2
export const SHOP_SUGGEST_SUBJECT_LENGTH = {
  MIN: 2,
  MAX: 100,
}
export const SHOP_SUGGEST_TEXT_LENGTH = {
  MIN: 2,
  MAX: 2000,
}
